import { isEmpty } from "radash";

export type HeaderRouteLink = {
  // Name as defined in the router
  routeName: string;
  // Resources in the route, path/:id
  params?: Record<string, string>;
  // Query params to pass along with the route:
  // Resulting in /routePath?item1Key=item1Value
  query?: Record<string, string>;
};

export type HeaderUrlLink = {
  // Url to open when clicking on this link
  url: string;
};

export type HeaderBaseLink = (HeaderRouteLink | HeaderUrlLink | object) & {
  // Localised name
  name: string;
  // Action to perform when clicking on this link
  action?: () => void;
};

export type HeaderRootLink = HeaderBaseLink & {
  // Child links, depth is limited to one
  links?: Record<string, HeaderBaseLink>;
  // Whether to add a flex space before the link
  growBefore?: boolean;
};

// not sure how to check if link satisfies type `HeaderUrlLink` without type prop workarounds
export const isUrlLink = (link: HeaderBaseLink | HeaderRouteLink | HeaderUrlLink): link is HeaderUrlLink => {
  return "url" in link && !isEmpty(link.url);
};

export const isRouteLink = (link: HeaderBaseLink | HeaderRouteLink | HeaderUrlLink): link is HeaderRouteLink => {
  return "routeName" in link && !isEmpty(link.routeName);
};

export const linkOnlyHasAction = (link: HeaderBaseLink) =>
  isEmpty((link as any).url) && isEmpty((link as any).routeName) && !isEmpty((link as any).action);

export const getRouteForLink = (link: HeaderRouteLink) => ({ name: link.routeName, params: link.params, query: link.query });
